import React from 'react';

const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();

  const footerLinks = {
    company: [
      { name: 'About Us', href: '#about' },
      { name: 'Our Team', href: '#about' },
      { name: 'Careers', href: '#contact' },
      { name: 'Press', href: '#contact' }
    ],
    services: [
      { name: 'E-Commerce', href: '#services' },
      { name: 'Accounting', href: '#services' },
      { name: 'Restaurant Management', href: '#services' },
      { name: 'Enterprise Solutions', href: '#services' }
    ],
    support: [
      { name: 'Help Center', href: '#contact' },
      { name: 'Documentation', href: '#contact' },
      { name: 'API Reference', href: '#contact' },
      { name: 'Status Page', href: '#contact' }
    ],
    legal: [
      { name: 'Privacy Policy', href: '#contact' },
      { name: 'Terms of Service', href: '#contact' },
      { name: 'Cookie Policy', href: '#contact' },
      { name: 'GDPR', href: '#contact' }
    ]
  };

  return (
    <footer className="bg-teknura-dark border-t-2 border-teknura-red">
      <div className="container mx-auto px-4 py-12">
        {/* Main Footer Content */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-8 mb-8">
          {/* Company Info */}
          <div className="lg:col-span-2">
            <div className="flex items-center space-x-2 mb-4">
              <div className="w-8 h-8 bg-teknura-red border-2 border-teknura-red rounded"></div>
              <h3 className="text-xl font-bold text-teknura-white">TEKNURA.COM</h3>
            </div>
            <p className="text-teknura-light-gray mb-4 max-w-md">
              Empowering businesses with innovative technology solutions. 
              We build the future, one line of code at a time.
            </p>
            {/* <div className="flex space-x-4">
              <a href="#" className="text-teknura-red hover:text-teknura-blue transition-colors">
                📘
              </a>
              <a href="#" className="text-teknura-red hover:text-teknura-blue transition-colors">
                🐦
              </a>
              <a href="#" className="text-teknura-red hover:text-teknura-blue transition-colors">
                💼
              </a>
              <a href="#" className="text-teknura-red hover:text-teknura-blue transition-colors">
                📷
              </a>
            </div> */}
          </div>

          {/* Company Links */}
          <div>
            <h4 className="text-teknura-white font-bold mb-4 border-b border-teknura-red pb-2">
              COMPANY
            </h4>
            <ul className="space-y-2">
              {footerLinks.company.map((link, index) => (
                <li key={index}>
                  <a 
                    href={link.href} 
                    className="text-teknura-light-gray hover:text-teknura-red transition-colors text-sm"
                  >
                    {link.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Services Links */}
          <div>
            <h4 className="text-teknura-white font-bold mb-4 border-b border-teknura-red pb-2">
              SERVICES
            </h4>
            <ul className="space-y-2">
              {footerLinks.services.map((link, index) => (
                <li key={index}>
                  <a 
                    href={link.href} 
                    className="text-teknura-light-gray hover:text-teknura-red transition-colors text-sm"
                  >
                    {link.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Support Links */}
          <div>
            <h4 className="text-teknura-white font-bold mb-4 border-b border-teknura-red pb-2">
              SUPPORT
            </h4>
            <ul className="space-y-2">
              {footerLinks.support.map((link, index) => (
                <li key={index}>
                  <a 
                    href={link.href} 
                    className="text-teknura-light-gray hover:text-teknura-red transition-colors text-sm"
                  >
                    {link.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* Newsletter Signup */}
        {/* <div className="border-t border-teknura-red pt-8 mb-8">
          <div className="text-center">
            <h4 className="text-xl font-bold text-teknura-white mb-4">
              STAY UPDATED WITH TEKNURA
            </h4>
            <p className="text-teknura-light-gray mb-6 max-w-2xl mx-auto">
              Get the latest updates on our products, industry insights, and technology trends. 
              Join our newsletter and never miss out on important developments.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center items-center max-w-md mx-auto">
              <input 
                type="email" 
                placeholder="Enter your email address" 
                className="flex-1 px-4 py-2 border-2 border-teknura-border bg-teknura-white text-teknura-dark placeholder-teknura-light-gray focus:outline-none focus:border-teknura-red rounded"
              />
              <button className="bg-teknura-red text-teknura-white px-6 py-2 font-bold border-2 border-teknura-red hover:bg-transparent hover:text-teknura-red transition-colors whitespace-nowrap rounded">
                SUBSCRIBE
              </button>
            </div>
          </div>
        </div> */}

        {/* Bottom Footer */}
        <div className="border-t border-teknura-red pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <div className="text-teknura-light-gray text-sm mb-4 md:mb-0">
              © {currentYear} TEKNURA.COM. All rights reserved.
            </div>
            
            <div className="flex space-x-6">
              {footerLinks.legal.map((link, index) => (
                <a 
                  key={index}
                  href={link.href} 
                  className="text-teknura-light-gray hover:text-teknura-red transition-colors text-sm"
                >
                  {link.name}
                </a>
              ))}
            </div>
          </div>
        </div>

        {/* Coming Soon Notice */}
        <div className="mt-8 text-center">
          <div className="bg-teknura-white border border-teknura-red p-4 max-w-2xl mx-auto rounded">
            <p className="text-teknura-red text-sm">
              🚀 <strong>SHOP.TEKNURA.COM</strong> - Our e-commerce platform is coming soon! 
              Join the waitlist to be notified when we launch.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
